import type { Dayjs } from 'dayjs';

// Define interface for dayjs instance with timezone extension
interface DayjsWithTimezone extends Dayjs {
  $x?: {
    $timezone?: string;
  };
}

export const readableTimezone = (_: unknown, dayjsClass: typeof Dayjs) => {
  const originalFormat = dayjsClass.prototype.format;

  dayjsClass.prototype.format = function (template?: string | undefined) {
    const result = template?.replace(/\[([^\]]+)]|z/g, (match) => {
      if (match === 'z') {
        const timeZone = (this as DayjsWithTimezone).$x?.$timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone,
          timeZoneName: 'short',
        });

        const parts = formatter.formatToParts(this.toDate());
        const abbr = parts.find((p) => p.type === 'timeZoneName')?.value;

        return abbr ? `[${abbr}]` : `[${match}]`;
      }
      return match;
    });

    return originalFormat.bind(this)(result);
  };
};

export default readableTimezone;
